export default "__VITE_ASSET__B_6i4cq8__"